/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */
define('modules/InStorePickup/InStorePickup',[
    'jquery',
    'lodash',
    'global/all',
    'modules/Store/StoreLocationService',
    'modules/InStorePickup/InStorePickup.Forms',
    'modules/User/Users'
], function ($, _, Roc, StoreLocationService, InStorePickupForms, Users) {
    'use strict';

    var forms = InStorePickupForms;
    var currentProduct = null;
    var findStoreDeferred = null;

    var zipCodeCookieName = "isp_zip_code";
    var currentViewModel;
    
    /**
     * Adds an event handler for displaying store details on the right side of the modal
     * @returns {} 
     */
    function bindShowStoreDetailsEvt() {
        Roc.UI.siteBody
            .off('click', '[data-roc-action="showStoreDetails"]')
            .on('click', '[data-roc-action="showStoreDetails"]', function () {
                var $this = $(this);
                if (!$this.hasClass('item-selected')) {
                    $this.closest('.itemList.selectable').find('.item').removeClass('item-selected');
                    $this.addClass('item-selected');
                    var locationId = $this.attr('data-roc-locationId');
                    var selectedLocation = _.find(currentViewModel.results, function (pickupDetails) {
                        return pickupDetails.location.id === locationId;
                    });

                    StoreLocationService.getDefaultStoreId().then(function (id) {
                        selectedLocation.isUserDefaultStore = selectedLocation.location.id === id;
                    }).always(function () {
                        Roc.UI.template('deliveryOptionsStorePickupDetails-Tmp', selectedLocation)
                        .then(function (renderedTemplate) {
                            $this.closest('#store-pickup-modal').find('.storeDetails').html(renderedTemplate);
                        });
                    });
                }
            });
    }

    /**
     * Adds an event handler for saving store as default
     * @returns {} 
     */
    function bindSaveStoreAsDefaultEvt() {
        Roc.UI.siteBody
            .off('click', '[data-roc-action="saveAsDefaultStore"]')
            .on('click', '[data-roc-action="saveAsDefaultStore"]', function () {
                var $srcButton = $(this);
                var locationId = $srcButton.attr('data-roc-location-id');
                Roc.Core.lockButton('[data-roc-action="saveAsDefaultStore"]');
                StoreLocationService.setDefaultStoreId(locationId).then(function () {
                    Roc.Core.releaseLockedButton('[data-roc-action="saveAsDefaultStore"]');
                    $srcButton.html('Saved as your store');
                    $srcButton.removeClass('btnAction').attr('disabled', 'disabled');
                    // update data in memory
                    _.forEach(currentViewModel.results, function (store) {
                        store.isUserDefaultStore = store.id === locationId;
                    });
                }, function () {
                    Roc.UI.error("There was an unexpected error updating your store");
                    Roc.Core.releaseLockedButton('[data-roc-action="saveAsDefaultStore"]');
                });
            });
    }

    /**
     * Adds an event handler for selecting pickup store
     * @returns {} 
     */
    function bindPickupStoreSelectEvt() {
        Roc.UI.siteBody
            .off('click', '[data-roc-action="selectPickupStore"]')
            .on('click', '[data-roc-action="selectPickupStore"]', function () {
                var locationId = $(this).attr('data-roc-location-id');
                Roc.UI.Modal.close();
                var selectedStore = _.find(currentViewModel.results, function(pickupDetails) {
                    return pickupDetails.location.id === locationId;
                });
                if (selectedStore) {
                    findStoreDeferred.resolve(selectedStore);
                } else {
                    findStoreDeferred.reject();
                }
            });
    }

    /**
     * Adds an event handler for selecting pickup store and saving it as default store
     * @returns {} 
     */
    function bindPickupStoreSelectAndSaveAsDefaultEvt() {
        Roc.UI.siteBody
            .off('click', '[data-roc-action="selectPickupStoreAndSaveAsDefault"]')
            .on('click', '[data-roc-action="selectPickupStoreAndSaveAsDefault"]', function () {
                var locationId = $(this).attr('data-roc-location-id');
                var selectedStore = _.find(currentViewModel.results, function (pickupDetails) {
                    return pickupDetails.location.id === locationId;
                });

                if (selectedStore) {
                    StoreLocationService.setDefaultStoreId(selectedStore.location.id).then(function () {
                        Roc.UI.Modal.close();
                    },
                        function () {
                            Roc.UI.displayErrorPopup('There was an error when trying to save your store.');
                        }).always(function () {
                            findStoreDeferred.resolve(selectedStore);
                        });
                } else {
                    findStoreDeferred.reject();
                }
            });
    }

    /**
     * Adds an event handler for searching pickup locations
     * @returns {} 
     */
    function bindSearchLocationsEvt() {
        Roc.UI.siteBody
            .off('click', '[data-roc-action="searchPickupLocations"]')
            .on('click', '[data-roc-action="searchPickupLocations"]', function () {
                search();
            });

        Roc.UI.siteBody
            .off('keypress', '#isp-search-zip')
            .on('keypress', '#isp-search-zip', function (e) {
                if (e.keyCode === 13) {
                    search();
                }
            });
    }

    function displaySearchResultsModal() {
        $.extend(currentViewModel, { 'isLoggedIn': Users.isLoggedIn() });
        Roc.UI.template('storePickUpSearchResultsModal-Tmp', currentViewModel)
            .then(function (renderedTemplate) {
                bindSearchLocationsEvt();
                bindShowStoreDetailsEvt();
                bindSaveStoreAsDefaultEvt();
                bindPickupStoreSelectEvt();
                bindPickupStoreSelectAndSaveAsDefaultEvt();
                Roc.UI.Modal.open(renderedTemplate);
            });
    }

    function search() {
        if (Roc.Validation.validateForm(forms.searchStores)) {
            var formData = Roc.Forms.getFormValues(forms.searchStores);

            if (currentViewModel === undefined || currentViewModel === null
                || currentViewModel.zipCode === undefined || currentViewModel.zipCode === null
                || currentViewModel.zipCode !== formData.zip) {
                Roc.Core.lockButton('[data-roc-action="searchPickupLocations"]');

                StoreLocationService.searchByZip(formData.productId, formData.zip).then(
                    function (response) {
                        currentViewModel = {
                            product: currentProduct,
                            zipCode: formData.zip,
                            results: response
                        };
                        Roc.Core.createCookie(zipCodeCookieName, formData.zip, 1);
                        Roc.Core.releaseLockedButton('[data-roc-action="searchPickupLocations"]');
                        displaySearchResultsModal();
                    },
                    function () {
                        Roc.Core.releaseLockedButton('[data-roc-action="searchPickupLocations"]');
                        Roc.UI.displayErrorPopup('There was an error while searching store locations.');
                        findStoreDeferred.reject();
                    });
            }
        }
    }

    /**
     * Returns a promise object which is resolved with the selected store object.
     * @param {} product 
     * @returns {} 
     */
    function findPickupStore(product) {
        if (findStoreDeferred && findStoreDeferred.state() === "pending") {
            findStoreDeferred.reject();
        }

        findStoreDeferred = $.Deferred();
        currentProduct = product;

        Roc.UI.block();
        // try to get user's locations
        Roc.Geolocation.getPosition()
            .then(function (geoposition) {
                var geolocation = {
                    latitude: geoposition.coords.latitude,
                    longitude: geoposition.coords.longitude
                };
                // find the nearest stores by using geolocation
                StoreLocationService.searchByGeolocation(product.id, geolocation).then(
                    function (response) {
                        currentViewModel = {
                            product: currentProduct,
                            results: response
                        };
                        displaySearchResultsModal();
                        Roc.UI.unblock();
                    },
                    function () {
                        Roc.UI.unblock();
                        Roc.UI.displayErrorPopup('There was an error while searching store locations.');
                        findStoreDeferred.reject();
                    });
            }, function () {
                // user blocked geolocation permission request or geolocation is not supported
                // try to use zip code from previous search
                var zipCode = Roc.Core.readCookie(zipCodeCookieName);
                if (zipCode) {
                    StoreLocationService.searchByZip(product.id, zipCode).then(
                        function (response) {
                            currentViewModel = {
                                product: currentProduct,
                                zipCode: zipCode,
                                results: response
                            };
                            displaySearchResultsModal();
                            Roc.UI.unblock();
                        },
                        function () {
                            Roc.UI.unblock();
                            Roc.Core.eraseCookie(zipCodeCookieName);
                            Roc.UI.displayErrorPopup('There was an error while searching store locations.');
                            findStoreDeferred.reject();
                        });
                } else {
                    // if there's no zip code, open zip code search modal
                    Roc.UI.template('storePickUpModalSearchLocations-Tmp', {
                        'productId': product.id
                    })
                        .then(function (renderedTemplate) {
                            Roc.UI.unblock();
                            bindSearchLocationsEvt();
                            Roc.UI.Modal.open(renderedTemplate);
                        });
                }
            });
        
        return findStoreDeferred;
    }

    var InStorePickup = {
        findPickupStore: findPickupStore
    };

    Roc.Logger.debug('InStorePickup.js Loaded:', InStorePickup);

    return InStorePickup;

});
